
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ContactForm } from './ContactForm';
import { DirectContact } from './DirectContact';
import { useContactForm } from './useContactForm';

export const ContactCard = () => {
  const { 
    contactMethod,
    setContactMethod,
    formSubmitted,
  } = useContactForm();

  return (
    <Card className="w-full max-w-3xl mx-auto mt-8 overflow-visible shadow-lg border-sage-200">
      <CardContent className="p-0">
        <Tabs 
          defaultValue={contactMethod} 
          onValueChange={(value) => setContactMethod(value)} 
          className="w-full"
        >
          <TabsList className="grid w-full grid-cols-2 rounded-none rounded-t-lg">
            <TabsTrigger 
              value="form" 
              className="rounded-tl-lg data-[state=active]:bg-sage-50"
            >
              Contact Form
            </TabsTrigger>
            <TabsTrigger 
              value="direct" 
              className="rounded-tr-lg data-[state=active]:bg-sage-50"
            >
              Direct Contact
            </TabsTrigger>
          </TabsList>
          <TabsContent value="form" className="p-6 bg-sage-50/50">
            <ContactForm />
          </TabsContent>
          <TabsContent value="direct" className="p-6 bg-sage-50/50">
            <DirectContact />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};
